import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {Tab} from '@models/tab';
import {Location} from '@angular/common';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import {AdService} from '@services/ad.service';
import {Title} from '@angular/platform-browser';
import {City} from '@models/city';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {TrackingService} from '@services/tracking.service';

@Component({
    selector: 'app-ville',
    templateUrl: './ville.component.html',
    styleUrls: ['./ville.component.scss']
})
export class VilleComponent implements OnInit {

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    tabs: Tab[] = [];
    tab: Tab;
    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    currentUser = null;
    params;
    ready = false

    constructor(
        public dialog: MatDialog,
        private location: Location,
        private route: ActivatedRoute,
        private adService: AdService,
        private titleService: Title,
        private http: HttpClient,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.titleService.setTitle('LyBox - Analyse d\'une ville');
        this.favorite = this.adService.getEmptyFavorite();
        this.route.data.subscribe(data => {
            this.tabs = data.tabs;
            this.tab = data.tab;
        });

        this.route.params.subscribe(params => {
            this.params = params;
            if (params.code !== undefined) {
                this.http.get<City>(environment.apiUrl + 'app/city/' + params.code).subscribe(c => {
                    this.favorite.ad_city = c;
                    this.favorite = this.adService.cleanInput(this.favorite);
                    this.favorite = this.adService.updateValues(this.favorite);
                    this.ready = true
                });
            } else {
                this.ready = true
            }
        });
    }

    updateAd() {
        this.location.replaceState('/app/tools/ville/' + this.favorite.ad_city.city_code);
    }
}
